import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Checkbox, FormControlLabel } from "@mui/material";
import classes from "./Modal.module.css";
import { useState } from "react";

const Modal = ({
  open,
  handleClose = () => { },
  children,
  title,
  showActions = false,
  confirmBtnText,
  width,
  handleConfirm,
  confirmBtnColor = "primary",
  height = "100%",
  actionsClassName = "",
  confirmBtnDisabled,
  showLaunchDialog = false
}) => {
  const [check, setCheck] = useState(false);

  const onCheckboxChange = (value) => {
    setCheck(value)
    localStorage.setItem("showLaunchMessage", value)
  }

  return (
    <Dialog
      open={open}
      disableRestoreFocus
      onClose={() => {
        handleClose();
      }}
      // sx={{
      //   height: height,
      // }}
      // PaperProps={{
      //   sx: {
      //    width: "100%",
      //     maxWidth: `${width}px!important`,
      //   },
      // }}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: `${width}px`,
          maxHeight: height ? height : "80vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <div className={classes.header}>
        <DialogTitle className={classes.title}>{title}</DialogTitle>
        {!showLaunchDialog &&
          <IconButton id="close_id" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        }
      </div>
      <DialogContent className={classes.content}>{children}</DialogContent>
      {showLaunchDialog &&
        <div className={classes.checkboxRow}>
          <FormControlLabel
            control={
              <Checkbox
                checked={check}
                onChange={(e) => onCheckboxChange(e.target.checked)}
              />
            }
            label="Skip this message next time"

          />
        </div>
      }
      {showActions && (
        <DialogActions
          className={actionsClassName ? actionsClassName : classes.actions}
        >
          {!showLaunchDialog &&
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
          }
          <Button
            onClick={handleConfirm}
            color={confirmBtnColor}
            variant="contained"
            disabled={confirmBtnDisabled}
          >
            {confirmBtnText || "Ok"}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
